import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminUsers = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">👥 Хэрэглэгч Удирдах</h1>
        </div>

        <div className="admin-main">
          <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
            <p style={{ fontSize: '18px', marginBottom: '15px' }}>⏳ Энэ хэсэг ирээдүйд хөгжүүлэх гэж байна</p>
            <p style={{ fontSize: '14px', color: '#999' }}>Хэрэглэгч удирдах функцийн хөгжүүлэлт эхэлнэ</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;

/*
// ORIGINAL CODE - COMMENTED OUT FOR FUTURE USE
import React, { useState, useEffect } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Mock data
    const mockUsers = [
      { id: 1, name: 'Батаа', email: 'bataa@example.com', role: 'Хэрэглэгч', joinDate: '2024-01-15' },
      { id: 2, name: 'Сүхээ', email: 'sukhee@example.com', role: 'Хэрэглэгч', joinDate: '2024-02-20' },
      { id: 3, name: 'Энхцэцэг', email: 'enkhtsetseg@example.com', role: 'Хэрэглэгч', joinDate: '2024-03-10' },
    ];
    setUsers(mockUsers);
  }, []);

  const handleDeleteUser = (id) => {
    if (window.confirm('Энэ хэрэглэгчийг устгахдаа итгэлтэй байна уу?')) {
      setUsers(users.filter((u) => u.id !== id));
    }
  };

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">👥 Хэрэглэгч Удирдах</h1>
          <span style={{ color: '#ddd' }}>Нийт: {users.length}</span>
        </div>

        <div className="admin-main">
          {users.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
              <p>Хэрэглэгч олдсонгүй</p>
            </div>
          ) : (
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Нэр</th>
                  <th>Имэйл</th>
                  <th>Үүрэг</th>
                  <th>Нэгдсэн Огноо</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>{user.joinDate}</td>
                    <td>
                      <button
                        onClick={() => handleDeleteUser(user.id)}
                        className="admin-btn admin-btn-danger"
                        style={{ fontSize: '12px', padding: '6px 12px' }}
                      >
                        🗑️ Устгах
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
*/
